import { render, staticRenderFns } from "./BiochemUManEx4DataPartD.vue?vue&type=template&id=406fd432&scoped=true&"
import script from "./BiochemUManEx4DataPartD.vue?vue&type=script&lang=js&"
export * from "./BiochemUManEx4DataPartD.vue?vue&type=script&lang=js&"
import style0 from "./BiochemUManEx4DataPartD.vue?vue&type=style&index=0&id=406fd432&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406fd432",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
